import * as React from "react";
import { sendRequest } from "../../helpers/ajax";
import ILicenseKeySearchResult from "../../types/ILicenseKeySearchResults";
import IResponse from "../../types/IResponse";
import LicenseKeyList from "./LicenseKeyList";

interface ILicenseKeyListState {
    records: ILicenseKeySearchResult[];
    loading: boolean;
}

class LicenseKeyListContainer extends React.Component<{}, ILicenseKeyListState> {

    constructor(props: {}) {
        super(props);

        this.state = {
            records: [],
            loading: false
        };

        this.search = this.search.bind(this);
    }

    public render() {
        return (
            <LicenseKeyList
                loading={this.state.loading}
                records={this.state.records}
                search={this.search}
            />
        );
    }

    private async search() {
        this.setState({ loading: true });

        const result = await sendRequest<IResponse<ILicenseKeySearchResult[]>>("/api/licenseKeys/search", "POST");
        if (result && result.success) {
            this.setState({ records: result.payload, loading: false});
        } else {
            this.setState({ records: [], loading: false });
        }
    }
}

export default LicenseKeyListContainer;



// WEBPACK FOOTER //
// ./src/components/LicenseKeyList/LicenseKeyListContainer.tsx